import { BannerRequestImpl } from '../../../../core/api/banner/getbanner/bannerrequest';
import { BannerResponse } from '../../../../core/api/banner/getbanner/bannerresponse';
import { AddToBlacklistRequestImpl } from '../../../../core/api/blacklist/addtoblacklist/addtoblacklistrequest';
import { AddToBlacklistResponse } from '../../../../core/api/blacklist/addtoblacklist/addtoblacklistresponse';
import { ViewBlacklistRequestImpl } from '../../../../core/api/blacklist/viewblacklist/viewblacklistrequest';
import { ViewBlacklistResponse } from '../../../../core/api/blacklist/viewblacklist/viewblacklistresponse';
import { CategoriesRequestImpl } from '../../../../core/api/categories/categoriesrequest';
import { CategoriesResponse } from '../../../../core/api/categories/categoriesresponse';
import { FeaturedCategoriesRequestImpl } from '../../../../core/api/featuredcategories/featuredcategoriesrequest';
import { FeaturedCategoriesResponse } from '../../../../core/api/featuredcategories/featuredcategoriesresponse';
import { CreateGroupRequestImpl } from '../../../../core/api/group/creategroup/creategrouprequest';
import { CreateGroupResponse } from '../../../../core/api/group/creategroup/creategroupresponse';
import { DeleteGroupRequestImpl } from '../../../../core/api/group/deletegroup/deletegrouprequest';
import { DeleteGroupResponse } from '../../../../core/api/group/deletegroup/deletegroupresponse';
import { EditGroupRequestImpl } from '../../../../core/api/group/editgrop/editgrouprequest';
import { EditGroupResponse } from '../../../../core/api/group/editgrop/editgroupresponse';
import { ListTonesRequestImpl } from '../../../../core/api/mytunes/listtones/listtonesrequest';
import { ListTonesResponse } from '../../../../core/api/mytunes/listtones/listtonesresponse';
import { TimeBasedSettingForAllCallersRequestImpl } from '../../../../core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersrequest';
import { TimeBasedSettingForAllCallersResponse } from '../../../../core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersresponse';
import { TimeBasedSettingForCallersGroupRequestImpl } from '../../../../core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgrouprequest';
import { TimeBasedSettingForCallersGroupResponse } from '../../../../core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupresponse';
import { TimeBasedSettingForSpecificCallerRequestImpl } from '../../../../core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerrequest';
import { TimeBasedSettingForSpecificCallerResponse } from '../../../../core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerresponse';
import { AddToBlacklistDtoImpl } from '../../../../core/dto/addtoblacklist/addtoblacklistdto';
import { BlacklistMemberDetailsDtoImpl } from '../../../../core/dto/addtoblacklist/blacklistmemberdetailsdto';
import { BannerDtoImpl } from '../../../../core/dto/banner/bannerdto';
//import { GetMusicBoxContentsRequestImpl } from '../../../../core/api/wishlist/getmusicboxcontents/getmusicboxcontentsrequest';
//import { GetMusicBoxContentsResponse } from '../../../../core/api/wishlist/getmusicboxcontents/getmusicboxcontentsresponse';
//import { GetMusicBoxContentsDtoImpl } from '../../../../core/dto/musicboxcontents/getmusicboxcontentsdto';
import { CategoryDtoImpl } from '../../../../core/dto/categories/categorydto';
import { CreateGroupDtoImpl } from '../../../../core/dto/creategroup/creategroupdto';
import { DeleteGroupDtoImpl } from '../../../../core/dto/deletegroup/deletegroupdto';
import { EditGroupDtoImpl } from '../../../../core/dto/editgroup/editgroupdto';
import { FeaturedCategoryDto, FeaturedCategoryDtoImpl } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { ListTonesDtoImpl } from '../../../../core/dto/listtones/listtonesdto';
import { MemberDetailsDtoImpl } from '../../../../core/dto/listtones/memberdetailsdto';
//import { GetKaroakeListDtoImpl } from '../../../../core/dto/getkaroakelist/getkaroakelistdto';
//import { GetKaroakeListRequestImpl } from '../../../../core/api/karoake/getkaroakelist/getkaroakelistrequest';
//import { GetKaroakeListResponse } from '../../../../core/api/karoake/getkaroakelist/getkaroakelistresponse';
import { TimeBasedSettingForAllCallersDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforallcallersdto';
import { TimeBasedSettingForCallersGroupDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { TimeBasedSettingForSpecificCallerDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforspecificcallerdto';
import { ToneDtoImpl } from '../../../../core/dto/tonedto';
import { ViewBlacklistDtoImpl } from '../../../../core/dto/viewblacklist/viewblacklistdto';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { APIModel, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { RemoveFromBlacklistDtoImpl } from '../../../../core/dto/removefromblacklist/removefromblacklistdto';
import { RemoveFromBlacklistResponse } from '../../../../core/api/blacklist/removefromblacklist/removefromblacklistresponse';
import { RemoveFromBlacklistRequestImpl } from '../../../../core/api/blacklist/removefromblacklist/removefromblacklistrequest';
import { AddNameTuneDtoImpl } from '../../../../core/dto/addnametune/addnametunedto';
import { AddNameTuneResponse } from '../../../../core/api/nametune/addnametuneresponse';
import { AddNameTuneRequestImpl } from '../../../../core/api/nametune/addnametunerequest';
//import { SearchToneDtoImpl } from '../../../../core/dto/searchtone/searchtonedto';
//import { SearchToneResponse } from '../../../../core/api/search/searchtone/searchtoneresponse';
//import { SearchToneRequestImpl } from '../../../../core/api/search/searchtone/searchtonerequest';
import { SpecificSearchToneDtoImpl } from '../../../../core/dto/specificsearchtone/specificsearchtonedto';
import { SpecificSearchToneResponse } from '../../../../core/api/search/specificsearchtone/specificsearchtoneresponse';
import { SpecificSearchToneRequestImpl } from '../../../../core/api/search/specificsearchtone/specificsearchtonerequest';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { SettingsResponse } from 'src/com/sixdee/crbtportal/core/api/settings/settingsresponse';
import { SettingsRequestImpl } from 'src/com/sixdee/crbtportal/core/api/settings/settingsrequest';
//import { BuyMusicChannelDtoImpl } from '../../../../core/dto/buymusicchannel/buymusicchanneldto';
//import { BuyMusicChannelRequestImpl } from '../../../../core/api/wishlist/buymusicchannel/buymusicchannelrequest';
//import { BuyMusicChannelResponse } from '../../../../core/api/wishlist/buymusicchannel/buymusicchannelresponse';
//import { AddToWishlistDtoImpl } from '../../../../core/dto/wishlist/addtowishlist/addtowishlistdto';
//import { AddToWishlistResponse } from '../../../../core/api/wishlist/addtowishlist/addtowishlistresponse';
//import { AddToWishlistRequestImpl } from '../../../../core/api/wishlist/addtowishlist/addtowishlistrequest';

export interface HomeAPIModel extends APIModel
{
    getSettings(): void;
    getCategories(): void;
    getBanners(): void; 
    getFeaturedCategories(): void;
    getLoadMoreFeatureCategoriesTones(featuredCategorydto: FeaturedCategoryDto, startIndex: number, offset: number): void;
}

export class HomeAPIModelImpl extends APIModelImpl implements HomeAPIModel
{
   getSettings(): void 
   {    
    this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().getSettings()
        .success((settingsResponse: SettingsResponse) => {
          this.getAPIModelHandler().onSuccess(settingsResponse.getAPIFeature(), 
          settingsResponse.getDescription(), settingsResponse); 
        })
        .failure((settingsResponse: SettingsResponse) => {
          this.getAPIModelHandler().onFailure(settingsResponse.getAPIFeature(), 
          settingsResponse.getDescription(), settingsResponse);
        })
        .execute(new SettingsRequestImpl());
      }

    getCategories(): void 
    {
        let categoryDto = new CategoryDtoImpl();
        categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
        this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory().getCategories()
                   .success((categoriesResponse : CategoriesResponse)=>
                    {
                        this.getAPIModelHandler().onSuccess(categoriesResponse.getAPIFeature(), 
                        categoriesResponse.getDescription(), categoriesResponse.getCategoriesList()); 
                    })
                  .failure((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(categoriesResponse.getAPIFeature(), 
                      categoriesResponse.getDescription(), categoriesResponse);
                    })
                  .execute(new CategoriesRequestImpl(categoryDto));

                  this.callTestAPIs();
    }

    getBanners(): void 
    {
        let bannerDto = new BannerDtoImpl();
        bannerDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getBannerAPIProcessorFactory().getBanners()
                .success((bannerResponse: BannerResponse)=>
                {
                   this.getAPIModelHandler().onSuccess(bannerResponse.getAPIFeature(), 
                   bannerResponse.getDescription(), bannerResponse.getListOfBannerDtos());
                })
                .failure((bannerResponse: BannerResponse)=>
                {
                    this.getAPIModelHandler().onFailure(bannerResponse.getAPIFeature(), 
                    bannerResponse.getDescription(), undefined);
                })
                .execute(new BannerRequestImpl(bannerDto));
    }

    callTestAPIs(): void 
    {
        // this.nameTuneSearchAPI();
        //this.addNameTuneAPI();
    }

    nameTuneSearchAPI(): void
    {
        console.log("NAMETUNE SEARCH ########################################################4");
        let specificSearchToneDto = new SpecificSearchToneDtoImpl();
        specificSearchToneDto.setCategoryId("991"); // 1 or 697
        specificSearchToneDto.setToneId(0); //0 or 951829
        specificSearchToneDto.setPageNo(1);
        specificSearchToneDto.setPagePerCount(1);
        specificSearchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        specificSearchToneDto.setSearchKey("Esmallah");

        this.getAPIProcesssorFactory().getSpecificSearchToneProcessorFactory().getSpecificSearchTone()
        .success((specificSearchToneResponse: SpecificSearchToneResponse)=>
        {
            console.log("specific search success #######NAME TUNE SPECIFIC SEARCH############");
            this.getAPIModelHandler().onSuccess(specificSearchToneResponse.getAPIFeature(), 
            specificSearchToneResponse.getDescription(), specificSearchToneResponse.getSpecificSearchToneDto());
           
         })
        .failure((specificSearchToneResponse: SpecificSearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(specificSearchToneResponse.getAPIFeature(), 
           specificSearchToneResponse.getDescription(), undefined);
         })
        .execute(new SpecificSearchToneRequestImpl(specificSearchToneDto));
    }

    addNameTuneAPI(): void
    {
        console.log("NAMETUNE ##########################################################################3.1");

        let addNameTuneDto = new AddNameTuneDtoImpl();
        addNameTuneDto.setChannelId("9");
        addNameTuneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        addNameTuneDto.setToneId("");
        addNameTuneDto.setToneName("eyeur2");
        addNameTuneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        addNameTuneDto.setPackName("CRBT_MONTHLY");

        this.getAPIProcesssorFactory().getNameTuneProcessorFactory()
                     .getAddNameTuneAPIProcessor()
                  .success((addNameTuneResponse: AddNameTuneResponse)=>
                  {
                    console.log("NAMETUNE SUCCESS ######################################################3");
                     this.getAPIModelHandler().onSuccess(addNameTuneResponse.getAPIFeature(), 
                     addNameTuneResponse.getDescription(), addNameTuneResponse);
                  })
                  .failure((addNameTuneResponse: AddNameTuneResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(addNameTuneResponse.getAPIFeature(), 
                      addNameTuneResponse.getDescription(), undefined);
                  })
                  .execute(new AddNameTuneRequestImpl(addNameTuneDto));
    }
    
    getFeaturedCategories(): void 
    { 
        // this.getAPIModelHandler().onSuccess(APIFeatures.FEATURED_CATEGORIES, 
        //              "", this.getFeatured3());
         let featuredCategoryDto = new FeaturedCategoryDtoImpl();
         featuredCategoryDto.setIdentifier("NewReleases");
         featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.new_releases));
         featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
         featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
 
           this.getAPIProcesssorFactory().getFeaturedCategoriesAPIProcessorFactory()
                     .getFeaturedCategories()
                  .success((featuredCategoriesResponse: FeaturedCategoriesResponse)=>
                  {
                     this.getAPIModelHandler().onSuccess(featuredCategoriesResponse.getAPIFeature(), 
                     featuredCategoriesResponse.getDescription(), featuredCategoriesResponse.getFeaturedCategoryDto());
                  })
                  .failure((featuredCategoriesResponse : FeaturedCategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(featuredCategoriesResponse.getAPIFeature(), 
                      featuredCategoriesResponse.getDescription(), undefined);
                  })
                  .execute(new FeaturedCategoriesRequestImpl(featuredCategoryDto));
        
        this.getFeaturedCategoriesForJustForYou();
    }   

    getFeaturedCategoriesForJustForYou(): void 
    {
        console.log("getFeaturedCategoriesForJustForYou() invoked");

         let featuredCategoryDto = new FeaturedCategoryDtoImpl();
         featuredCategoryDto.setIdentifier("JUST_FOR_YOU");
         featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.just_for_you));
         featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
         featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
 
         this.getAPIProcesssorFactory().getFeaturedCategoriesAPIProcessorFactory()
                     .getFeaturedCategories()
                  .success((featuredCategoriesResponse: FeaturedCategoriesResponse)=>
                  {
                     this.getAPIModelHandler().onSuccess(featuredCategoriesResponse.getAPIFeature(), 
                     featuredCategoriesResponse.getDescription(), featuredCategoriesResponse.getFeaturedCategoryDto()); 
                  })
                  .failure((featuredCategoriesResponse : FeaturedCategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(featuredCategoriesResponse.getAPIFeature(), 
                      featuredCategoriesResponse.getDescription(), undefined);
                  })
                  .execute(new FeaturedCategoriesRequestImpl(featuredCategoryDto));

                //   this.listLikeToneAPI();
                // this.packStatusAPI();
                // this.getWishList();
                // this.addToWishList();
                //this.deleteFromWishList();
                 //this.getMusicBoxContentsAPI();
                // this.buyMusicChannelAPI();
                //  this.getMusicBoxContentsAPI();
                //this.logoutAPI();
                //this.transactionHistoryAPI();
                //this.salatiStatusAPI();
                //this.salatiActivateAPI();
                //this.specificSearchToneAPIWithToneIdAsSearchKey();
                //this.searchToneAPIWithToneIdAsSearchKey();
                // this.listTonesAPI();
                //  this.getKaroakeListAPI();
                //  this.getListTonesAPI();
                 //this.timeBasedSettingForAllCallerAPI();
                 //this.timeBasedSettingForCallersGroupAPI();
                 //this.timeBasedSettingForSpecificCallerAPI();
                // this.deleteGroupAPI();
                // this.createGroupAPI();
                // this.editGroupAPI();
                // this.viewBlacklistAPI();
                // this.addBlacklistAPI();
                // this.removeBlacklistAPI();
    }  

    getLoadMoreFeatureCategoriesTones(featuredCategorydto: FeaturedCategoryDto, startIndex: number, offset: number): void
    {
        this.getAPIModelHandler().onSuccess(APIFeatures.LOAD_MORE_TONES, 
            "", this.getFeatured3());
    }

   
    removeBlacklistAPI(): void 
    {
        console.log("removeBlacklistAPI() invoked ##########REMOVE BLACKLIST###############");
        let removeFromBlacklistDto = new RemoveFromBlacklistDtoImpl();
        removeFromBlacklistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        removeFromBlacklistDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        removeFromBlacklistDto.setChannelId("9");

        let membersDetailsDto = new BlacklistMemberDetailsDtoImpl();
        membersDetailsDto.setBPartyMsisdn("3333333333");
        removeFromBlacklistDto.setMemberDetails([membersDetailsDto]);

        this.getAPIProcesssorFactory().getBlacklistProcessorFactory()
        .getRemoveFromBlacklistAPIProcessor()
        .success((removeFromBlacklistResponse: RemoveFromBlacklistResponse)=>
        {
            console.log("success() invoked ##########REMOVE BLACKLIST###############");

            this.getAPIModelHandler().onSuccess(removeFromBlacklistResponse.getAPIFeature(), 
            removeFromBlacklistResponse.getDescription(), removeFromBlacklistResponse);
         })
        .failure((removeFromBlacklistResponse: RemoveFromBlacklistResponse)=>
         {
           this.getAPIModelHandler().onFailure(removeFromBlacklistResponse.getAPIFeature(), 
           removeFromBlacklistResponse.getDescription(), undefined);
         })
        .execute(new RemoveFromBlacklistRequestImpl(removeFromBlacklistDto));
    }


    //clientTxnId=2130336492&language=English&aPartyMsisdn=0504843969&channelId=9&memberDetailList=[{"bPartyMsisdn":"8123812512","bPartyName":"shiv"}]
    addBlacklistAPI(): void 
    {
        console.log("addBlacklistAPI() invoked ##########ADD BLACKLIST###############");
        let addToBlacklistDto = new AddToBlacklistDtoImpl();
        addToBlacklistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        addToBlacklistDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        addToBlacklistDto.setChannelId("9");
        let membersDetailsDto = new BlacklistMemberDetailsDtoImpl();
        membersDetailsDto.setBPartyName("shiv3");
        membersDetailsDto.setBPartyMsisdn("3333333333");
        addToBlacklistDto.setMemberDetails([membersDetailsDto]);

        this.getAPIProcesssorFactory().getBlacklistProcessorFactory()
        .getAddToBlacklistAPIProcessor()
        .success((addToBlacklistResponse: AddToBlacklistResponse)=>
        {
            console.log("success() invoked ##########ADD BLACKLIST###############");

            this.getAPIModelHandler().onSuccess(addToBlacklistResponse.getAPIFeature(), 
            addToBlacklistResponse.getDescription(), addToBlacklistResponse);
         })
        .failure((addToBlacklistResponse: AddToBlacklistResponse)=>
         {
           this.getAPIModelHandler().onFailure(addToBlacklistResponse.getAPIFeature(), 
           addToBlacklistResponse.getDescription(), undefined);
         })
        .execute(new AddToBlacklistRequestImpl(addToBlacklistDto));
    }

    //clientTxnId=1727485453&language=English&aPartyMsisdn=0504843969&channelId=9&serviceId=1&activityId=4&rbtMode=101
    viewBlacklistAPI(): void 
    {
        console.log("viewBlacklistAPI() invoked ##########VIEW BLACKLIST###############");
        let viewBlacklistDto = new ViewBlacklistDtoImpl();
        viewBlacklistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        viewBlacklistDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        viewBlacklistDto.setChannelId("9");
        viewBlacklistDto.setServiceId("1");
        viewBlacklistDto.setActivityId("4");
        viewBlacklistDto.setRbtMode("101");

        this.getAPIProcesssorFactory().getBlacklistProcessorFactory()
        .getViewBlacklistAPIProcessor()
        .success((viewBlacklistResponse: ViewBlacklistResponse)=>
        {
            console.log("success() invoked ##########VIEW BLACKLIST###############");

            this.getAPIModelHandler().onSuccess(viewBlacklistResponse.getAPIFeature(), 
            viewBlacklistResponse.getDescription(), viewBlacklistResponse);
         })
        .failure((viewBlacklistResponse: ViewBlacklistResponse)=>
         {
           this.getAPIModelHandler().onFailure(viewBlacklistResponse.getAPIFeature(), 
           viewBlacklistResponse.getDescription(), undefined);
         })
        .execute(new ViewBlacklistRequestImpl(viewBlacklistDto));
    }


    //msisdn=504843969&groupName=hi edit&groupId=665&groupDesc=hi edit&memberDetails=[]&deleteMember=&toneDetails=["14558"]&priority=0&language=English
    editGroupAPI(): void 
    {
        console.log("editGroupAPI() invoked ##########EDIT GROUP###############");
        let editGroupDto = new EditGroupDtoImpl();
        editGroupDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        editGroupDto.setGroupName("rajesh4 edit");
        editGroupDto.setGroupId(673);
        editGroupDto.setGroupDesc("good edit");

        /* let membersDetailsDto = new MemberDetailsDtoImpl();
        membersDetailsDto.setMemberName("raj4");
        membersDetailsDto.setMsisdn("09986717444");
        editGroupDto.setMemberDetails([membersDetailsDto]); */
        editGroupDto.setMemberDetails([]);
        editGroupDto.setDeleteMember("");
        editGroupDto.setToneDetails("14558");
        editGroupDto.setPriority("0");
        editGroupDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getGroupProcessorFactory()
        .getEditGroupAPIProcessor()
        .success((editGroupResponse: EditGroupResponse)=>
        {
            console.log("success() invoked ##########EDIT GROUP###############");

            this.getAPIModelHandler().onSuccess(editGroupResponse.getAPIFeature(), 
            editGroupResponse.getDescription(), editGroupResponse);
         })
        .failure((editGroupResponse: EditGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(editGroupResponse.getAPIFeature(), 
           editGroupResponse.getDescription(), undefined);
         })
        .execute(new EditGroupRequestImpl(editGroupDto));
    }


    //aPartyMsisdn=504843969&groupName=hi&groupDesc=hi&memberDetails=[{"msisdn":"8123812512","memberName":"shiv"}]&toneDetails=["14558"]&priority=0
    createGroupAPI(): void 
    {
        console.log("createGroupAPI() invoked ##########CREATE GROUP###############");
        let createGroupDto = new CreateGroupDtoImpl();
        createGroupDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        createGroupDto.setGroupName("rajesh4");
        createGroupDto.setGroupDesc("rajesh4");

        let membersDetailsDto = new MemberDetailsDtoImpl();
        membersDetailsDto.setMemberName("raj4");
        membersDetailsDto.setMsisdn("09986717444");
        createGroupDto.setMemberDetails([membersDetailsDto]);

        createGroupDto.setToneDetails("14558");
        createGroupDto.setPriority("0");

        this.getAPIProcesssorFactory().getGroupProcessorFactory()
        .getCreateGroupAPIProcessor()
        .success((createGroupResponse: CreateGroupResponse)=>
        {
            console.log("success() invoked ##########CREATE GROUP###############");

            this.getAPIModelHandler().onSuccess(createGroupResponse.getAPIFeature(), 
            createGroupResponse.getDescription(), createGroupResponse);
         })
        .failure((createGroupResponse: CreateGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(createGroupResponse.getAPIFeature(), 
           createGroupResponse.getDescription(), undefined);
         })
        .execute(new CreateGroupRequestImpl(createGroupDto));
    } 

    deleteGroupAPI(): void 
    {
        console.log("deleteGroupAPI() invoked ##########DELETE GROUP###############");
        let deleteGroupDto = new DeleteGroupDtoImpl();
        deleteGroupDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        deleteGroupDto.setGroupId("671");
        deleteGroupDto.setGroupName("rajesh2");
        deleteGroupDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getGroupProcessorFactory()
        .getDeleteGroupAPIProcessor()
        .success((deleteGroupResponse: DeleteGroupResponse)=>
        {
            console.log("success() invoked ##########DELETE GROUP###############");

            this.getAPIModelHandler().onSuccess(deleteGroupResponse.getAPIFeature(), 
            deleteGroupResponse.getDescription(), deleteGroupResponse);
         })
        .failure((deleteGroupResponse: DeleteGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(deleteGroupResponse.getAPIFeature(), 
           deleteGroupResponse.getDescription(), undefined);
         })
        .execute(new DeleteGroupRequestImpl(deleteGroupDto));
    } 

    timeBasedSettingForAllCallerAPI(): void 
    {
        console.log("timeBasedSettingForAllCallerAPI() invoked ##########ALL CALLERS###############");
        let timeBasedSettingForAllCallersDto = new TimeBasedSettingForAllCallersDtoImpl();
        timeBasedSettingForAllCallersDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        timeBasedSettingForAllCallersDto.setToneId("953435");
        timeBasedSettingForAllCallersDto.setLanguage(this.getContext().getUserContext().getLanguage());
        timeBasedSettingForAllCallersDto.setPriority("0"); //Fixed value
        timeBasedSettingForAllCallersDto.setChannelId("9"); //Fixed value
        timeBasedSettingForAllCallersDto.setServiceId("17"); //Fixed value
        timeBasedSettingForAllCallersDto.setActivityId("1"); //Fixed value
        timeBasedSettingForAllCallersDto.setWeeklyDays(["Sun", "Mon", "Tue", "Wed", "Thu", "Sat"]);
        //timeBasedSettingForAllCallersDto.setWeeklyDays([]);
        //timeBasedSettingForAllCallersDto.setWeeklyStartTime("12:03");
        //timeBasedSettingForAllCallersDto.setWeeklyEndTime("16:05");
        // timeBasedSettingForAllCallersDto.setCustomizeStartDate("2020-07-23");
        // timeBasedSettingForAllCallersDto.setCustomizeEndDate("2020-07-25");
        // timeBasedSettingForAllCallersDto.setCustomizeStartTime("12:04");
        // timeBasedSettingForAllCallersDto.setCustomizeEndTime("16:10");

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getTimeBasedSettingForAllCallersAPIProcessor()
        .success((timeBasedSettingForAllCallersResponse: TimeBasedSettingForAllCallersResponse)=>
        {
            console.log("success() invoked ##########ALL CALLERS###############");
            this.getAPIModelHandler().onSuccess(timeBasedSettingForAllCallersResponse.getAPIFeature(), 
            timeBasedSettingForAllCallersResponse.getDescription(), timeBasedSettingForAllCallersResponse);
            console.log(JSON.stringify(timeBasedSettingForAllCallersResponse));
         })
        .failure((timeBasedSettingForAllCallersResponse: TimeBasedSettingForAllCallersResponse)=>
         {
           this.getAPIModelHandler().onFailure(timeBasedSettingForAllCallersResponse.getAPIFeature(), 
           timeBasedSettingForAllCallersResponse.getDescription(), undefined);
         })
        .execute(new TimeBasedSettingForAllCallersRequestImpl(timeBasedSettingForAllCallersDto));
    }

    timeBasedSettingForCallersGroupAPI(): void 
    {
        console.log("timeBasedSettingForCallersGroupAPI() invoked ##########CALLERS GROUP###############");
        let timeBasedSettingForCallersGroupDto = new TimeBasedSettingForCallersGroupDtoImpl();
        timeBasedSettingForCallersGroupDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        timeBasedSettingForCallersGroupDto.setToneId("953435");
        timeBasedSettingForCallersGroupDto.setLanguage(this.getContext().getUserContext().getLanguage());
        timeBasedSettingForCallersGroupDto.setPriority("0"); //Fixed value
        timeBasedSettingForCallersGroupDto.setChannelId("9"); //Fixed value
        timeBasedSettingForCallersGroupDto.setServiceId("2"); //Fixed value
        timeBasedSettingForCallersGroupDto.setActivityId("13"); //Fixed value
        timeBasedSettingForCallersGroupDto.setGroupId("655");
        timeBasedSettingForCallersGroupDto.setGroupName("Sunshine");
        timeBasedSettingForCallersGroupDto.setGroupDesc("good");
        timeBasedSettingForCallersGroupDto.setWeeklyDays(["Sun", "Mon", "Tue", "Wed", "Thu", "Sat"]);
        // timeBasedSettingForCallersGroupDto.setWeeklyStartTime("00:00");
        // timeBasedSettingForCallersGroupDto.setWeeklyEndTime("23:59");
        //timeBasedSettingForCallersGroupDto.setCustomizeStartDate("2020-07-23");
        //timeBasedSettingForCallersGroupDto.setCustomizeEndDate("2020-07-25");
        //timeBasedSettingForCallersGroupDto.setCustomizeStartTime("12:04");
        //timeBasedSettingForCallersGroupDto.setCustomizeEndTime("16:10");

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getTimeBasedSettingForCallersGroupAPIProcessor()
        .success((timeBasedSettingForCallersGroupResponse: TimeBasedSettingForCallersGroupResponse)=>
        {
            console.log("success() invoked ##########CALLERS GROUP###############");
            this.getAPIModelHandler().onSuccess(timeBasedSettingForCallersGroupResponse.getAPIFeature(), 
            timeBasedSettingForCallersGroupResponse.getDescription(), timeBasedSettingForCallersGroupResponse);
            console.log(JSON.stringify(timeBasedSettingForCallersGroupResponse));
         })
        .failure((timeBasedSettingForCallersGroupResponse: TimeBasedSettingForCallersGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(timeBasedSettingForCallersGroupResponse.getAPIFeature(), 
           timeBasedSettingForCallersGroupResponse.getDescription(), undefined);
         })
        .execute(new TimeBasedSettingForCallersGroupRequestImpl(timeBasedSettingForCallersGroupDto));
    }

    timeBasedSettingForSpecificCallerAPI(): void 
    {
        console.log("timeBasedSettingForSpecificCallerAPI() invoked ########## SPECIFIC CALLER###############");
        let timeBasedSettingForSpecificCallerDto = new TimeBasedSettingForSpecificCallerDtoImpl();
        timeBasedSettingForSpecificCallerDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        timeBasedSettingForSpecificCallerDto.setBPartyMsisdn("504843968");
        timeBasedSettingForSpecificCallerDto.setToneId("953435");
        timeBasedSettingForSpecificCallerDto.setLanguage(this.getContext().getUserContext().getLanguage());
        timeBasedSettingForSpecificCallerDto.setPriority("0"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setChannelId("9"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setServiceId("13"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setActivityId("1"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setPackName("CRBT_MONTHLY");
        timeBasedSettingForSpecificCallerDto.setWeeklyDays(["Sun", "Mon", "Tue", "Wed", "Thu", "Sat"]);
        // timeBasedSettingForSpecificCallerDto.setWeeklyStartTime("00:00");
        // timeBasedSettingForSpecificCallerDto.setWeeklyEndTime("23:59");
        //timeBasedSettingForSpecificCallerDto.setCustomizeStartDate("2020-07-23");
        //timeBasedSettingForSpecificCallerDto.setCustomizeEndDate("2020-07-25");
        //timeBasedSettingForSpecificCallerDto.setCustomizeStartTime("12:04");
        //timeBasedSettingForSpecificCallerDto.setCustomizeEndTime("16:10");

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getTimeBasedSettingForSpecificCallerAPIProcessor()
        .success((timeBasedSettingForSpecificCallerResponse: TimeBasedSettingForSpecificCallerResponse)=>
        {
            console.log("success() invoked ##########SPECIFIC CALLER###############");
            this.getAPIModelHandler().onSuccess(timeBasedSettingForSpecificCallerResponse.getAPIFeature(), 
            timeBasedSettingForSpecificCallerResponse.getDescription(), timeBasedSettingForSpecificCallerResponse);
            console.log(JSON.stringify(timeBasedSettingForSpecificCallerResponse));
         })
        .failure((timeBasedSettingForSpecificCallerResponse: TimeBasedSettingForSpecificCallerResponse)=>
         {
           this.getAPIModelHandler().onFailure(timeBasedSettingForSpecificCallerResponse.getAPIFeature(), 
           timeBasedSettingForSpecificCallerResponse.getDescription(), undefined);
         })
        .execute(new TimeBasedSettingForSpecificCallerRequestImpl(timeBasedSettingForSpecificCallerDto));
    }

   /*  getKaroakeListAPI(): void 
    {
        console.log("getKaroakeListAPI() invoked ##########KAROAKE LIST###############");
        let getKaroakeListDto = new GetKaroakeListDtoImpl();
        getKaroakeListDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getKaroakeListDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getKaroakeListDto.setChannelId("9");
        getKaroakeListDto.setServiceId("4");

        this.getAPIProcesssorFactory().getKaroakeProcessorFactory()
        .getKaroakeListDetails()
        .success((getKaroakeListResponse: GetKaroakeListResponse)=>
        {
            console.log("success() invoked ##########KAROAKE LIST###############");

            this.getAPIModelHandler().onSuccess(getKaroakeListResponse.getAPIFeature(), 
            getKaroakeListResponse.getDescription(), getKaroakeListResponse);
            console.log(JSON.stringify(getKaroakeListResponse.getKaroakeListDto()));
         })
        .failure((getKaroakeListResponse: GetKaroakeListResponse)=>
         {
           this.getAPIModelHandler().onFailure(getKaroakeListResponse.getAPIFeature(), 
           getKaroakeListResponse.getDescription(), undefined);
         })
        .execute(new GetKaroakeListRequestImpl(getKaroakeListDto));
    } */

    
    getListTonesAPI(): void 
    {
        console.log("listTonesAPI() invoked ##########LIST TONES###############");
        let listTonesDto = new ListTonesDtoImpl();
        listTonesDto.setLanguage(this.getContext().getUserContext().getLanguage());
        listTonesDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        listTonesDto.setStartIndex("0");
        listTonesDto.setEndIndex("20");
        listTonesDto.setRbtMode("300"); // 0 for ALL,   400 for TUNES,  300 for PLAYLIST, 2 for GetGroup

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getListTonesForPlaylistAPIProcessor()
        .success((listTonesResponse: ListTonesResponse)=>
        {
            console.log("success() invoked ##########LIST TONES###############");
            console.log("1: "+JSON.stringify(listTonesResponse));
            console.log("2: "+JSON.stringify(listTonesResponse.getListTonesResponseDtos()));
            this.getAPIModelHandler().onSuccess(listTonesResponse.getAPIFeature(), 
            listTonesResponse.getDescription(), listTonesResponse.getListTonesResponseDtos());
         })
        .failure((listTonesResponse : ListTonesResponse)=>
         {
           this.getAPIModelHandler().onFailure(listTonesResponse.getAPIFeature(), 
           listTonesResponse.getDescription(), undefined);
         })
        .execute(new ListTonesRequestImpl(listTonesDto));
    }

    
    /*  searchToneAPIWithToneIdAsSearchKey(): void 
    {
        console.log("searchToneAPIWithToneIdAsSearchKey() invoked ##########SEARCH TONE###############");
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(20);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        //searchToneDto.setSearchKey("Recently+Added"); 
        searchToneDto.setSearchKey("297256"); // 802281-465 or 297256-565
        searchToneDto.setCategoryId(565);
        searchToneDto.setSortBy("Order_By");
        searchToneDto.setAlignBy("ASC");
        searchToneDto.setPageNo(1);
        searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getSearchTone()
        .success((searchToneResponse: SearchToneResponse)=>
        {
            console.log("success() invoked ##########SEARCH TONE###############");

            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), searchToneResponse);

         })
        .failure((searchToneResponse : SearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
           
    } */

      /* specificSearchToneAPIWithToneIdAsSearchKey(): void 
    {
        console.log("specificSearchToneAPIWithToneIdAsSearchKey() invoked ##########SPECIFIC SEARCH###############");
        let specificSearchToneDto = new SpecificSearchToneDtoImpl();
        specificSearchToneDto.setSearchKey("182195"); // 170656
        specificSearchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        specificSearchToneDto.setCategoryId(1); // 1 or 697
        specificSearchToneDto.setToneId(0); //0 or 951829
        specificSearchToneDto.setPageNo(1);
        specificSearchToneDto.setPagePerCount(1);
        specificSearchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSpecificSearchToneProcessorFactory().getSpecificSearchTone()
        .success((specificSearchToneResponse: SpecificSearchToneResponse)=>
        {
            console.log("specific search success ##########SPECIFIC SEARCH###############");
            this.getAPIModelHandler().onSuccess(specificSearchToneResponse.getAPIFeature(), 
            specificSearchToneResponse.getDescription(), specificSearchToneResponse.getSpecificSearchToneDto());
           
         })
        .failure((specificSearchToneResponse: SpecificSearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(specificSearchToneResponse.getAPIFeature(), 
           specificSearchToneResponse.getDescription(), undefined);
         })
        .execute(new SpecificSearchToneRequestImpl(specificSearchToneDto));
    } */

    /* salatiActivateAPI(): void 
    {
        console.log("salatiActivateAPI() invoked ##########SALATI ACTIVATE###############");
        let salatiActivationDto = new SalatiActivationDtoImpl();
        salatiActivationDto.setChannelId("1");  // 1 is fixed
        salatiActivationDto.setServiceId("15"); // 15 is fixed 
        salatiActivationDto.setActivityId("1"); // 5 is fixed
        salatiActivationDto.setPaymentMode("2"); // 2 is fixed
        salatiActivationDto.setPriority("0"); // 0 is fixed
        salatiActivationDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        salatiActivationDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSalatiProcessorFactory()
        .getSalatiActivationDetails()
        .success((salatiActivationResponse: SalatiActivationResponse)=>
        {
            console.log("salatiActivateAPI success ###############SALATI ACTIVATE#################");
            this.getAPIModelHandler().onSuccess(salatiActivationResponse.getAPIFeature(), 
            salatiActivationResponse.getDescription(), salatiActivationResponse);
          
         })
        .failure((salatiActivationResponse: SalatiActivationResponse)=>
         {
           this.getAPIModelHandler().onFailure(salatiActivationResponse.getAPIFeature(), 
           salatiActivationResponse.getDescription(), undefined);
         })
        .execute(new SalatiActivationRequestImpl(salatiActivationDto));
    } */ 


    /*  salatiStatusAPI(): void 
    {
        console.log("salatiStatusAPI() invoked ##########SALATI STATUS###############");
        let salatiStatusDto = new SalatiStatusDtoImpl();
        salatiStatusDto.setChannelId("1");  // 1 is fixed
        salatiStatusDto.setServiceId("15"); // 15 is fixed 
        salatiStatusDto.setActivityId("5"); // 5 is fixed
        salatiStatusDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        salatiStatusDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
        console.log("SalatiStatusDto : " +JSON.stringify(salatiStatusDto));

        this.getAPIProcesssorFactory().getSalatiProcessorFactory()
        .getSalatiStatusDetails()
        .success((salatiStatusResponse: SalatiStatusResponse)=>
        {
            console.log("salatiStatusAPI success ###############SALATI STATUS#################");
            this.getAPIModelHandler().onSuccess(salatiStatusResponse.getAPIFeature(), 
            salatiStatusResponse.getDescription(), salatiStatusResponse.getListOfSalatiStatusDtos());
          
         })
        .failure((salatiStatusResponse: SalatiStatusResponse)=>
         {
           this.getAPIModelHandler().onFailure(salatiStatusResponse.getAPIFeature(), 
           salatiStatusResponse.getDescription(), undefined);
         })
        .execute(new SalatiStatusRequestImpl(salatiStatusDto));
    } */ 

//msisdn=504843969&fromDate=10-05-2020&toDate=09-06-2020&language=English
   /*  transactionHistoryAPI(): void 
    {
        console.log("transactionHistoryAPI() invoked ##########TRANSACTION_HISTORY###############");
        let transactionHistoryDto = new TransactionHistoryDtoImpl();
        transactionHistoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        transactionHistoryDto.setFromDate("10-05-2020");
        transactionHistoryDto.setToDate("09-06-2020");

        this.getAPIProcesssorFactory().getMyAccountProcessorFactory()
        .getTransactionHistoryDetails()
        .success((transactionHistoryResponse: TransactionHistoryResponse)=>
        {
            console.log("transactionHistoryAPI success ###############TRANSACTION_HISTORY#################");
            this.getAPIModelHandler().onSuccess(transactionHistoryResponse.getAPIFeature(), 
            transactionHistoryResponse.getDescription(), transactionHistoryResponse.getTransactionHistoryDtos());
          
         })
        .failure((transactionHistoryResponse: TransactionHistoryResponse)=>
         {
           this.getAPIModelHandler().onFailure(transactionHistoryResponse.getAPIFeature(), 
           transactionHistoryResponse.getDescription(), undefined);
         })
        .execute(new TransactionHistoryRequestImpl(transactionHistoryDto));
    } */

      /*   private getWishList(): void 
     { 
             console.log("getWishList() invoked ##########WISHLIST###############");
             let getWishlistDto = new GetWishlistDtoImpl();
             getWishlistDto.setIdentifier("ViewWishListItems");
             getWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
             getWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
             getWishlistDto.setWishlistType("1"); // 1 for tunes,  2 for playlist
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getGetWishlist()
             .success((getWishlistResponse: GetWishlistResponse)=>
             {
                 console.log("getWishList success ###############WISHLIST#################");
                 this.getAPIModelHandler().onSuccess(getWishlistResponse.getAPIFeature(), 
                 getWishlistResponse.getDescription(), getWishlistResponse.getGetWishlistDto());
               
              })
             .failure((getWishlistResponse: GetWishlistResponse)=>
              {
                this.getAPIModelHandler().onFailure(getWishlistResponse.getAPIFeature(), 
                getWishlistResponse.getDescription(), undefined);
              })
             .execute(new GetWishlistRequestImpl(getWishlistDto));
     }  */  

    /*  private getMusicBoxContentsAPI(): void 
     { 
             console.log("getMusicBoxContentsAPI() invoked ##########MUSICBOX CONTENTS###############");
             let getMusicBoxContentsDto = new GetMusicBoxContentsDtoImpl();
             getMusicBoxContentsDto.setToneCode("6015090011");
             getMusicBoxContentsDto.setLanguage(this.getContext().getUserContext().getLanguage());
             getMusicBoxContentsDto.setType("MB");
             getMusicBoxContentsDto.setPageNo("1");
             getMusicBoxContentsDto.setPerPageCount("20");
    //  private getMusicBoxContentsAPI(): void 
    //  { 
    //          console.log("getMusicBoxContentsAPI() invoked ##########MUSICBOX CONTENTS###############");
    //          let getMusicBoxContentsDto = new GetMusicBoxContentsDtoImpl();
    //          getMusicBoxContentsDto.setToneCode("6015090011");
    //          getMusicBoxContentsDto.setLanguage(this.getContext().getUserContext().getLanguage());
    //          getMusicBoxContentsDto.setType("MB");
    //          getMusicBoxContentsDto.setPageNo("1");
    //          getMusicBoxContentsDto.setPerPageCount("20");
    
    //          this.getAPIProcesssorFactory().getToneProcessorFactory()
    //          .getMusicBoxContents()
    //          .success((getMusicBoxContentsResponse: GetMusicBoxContentsResponse)=>
    //          {
    //              console.log("getMusicBoxContentsAPI success ###############MUSICBOX CONTENTS#################");
    //              this.getAPIModelHandler().onSuccess(getMusicBoxContentsResponse.getAPIFeature(), 
    //              getMusicBoxContentsResponse.getDescription(), getMusicBoxContentsResponse.getMusicBoxContentsDto());
               
              })
             .failure((getMusicBoxContentsResponse: GetMusicBoxContentsResponse)=>
              {
                this.getAPIModelHandler().onFailure(getMusicBoxContentsResponse.getAPIFeature(), 
                getMusicBoxContentsResponse.getDescription(), undefined);
              })
             .execute(new GetMusicBoxContentsRequestImpl(getMusicBoxContentsDto));
     } */ 
    //           })
    //          .failure((getMusicBoxContentsResponse: GetMusicBoxContentsResponse)=>
    //           {
    //             this.getAPIModelHandler().onFailure(getMusicBoxContentsResponse.getAPIFeature(), 
    //             getMusicBoxContentsResponse.getDescription(), undefined);
    //           })
    //          .execute(new GetMusicBoxContentsRequestImpl(getMusicBoxContentsDto));
    //  } 



//serviceId=7&aPartyMsisdn=0504843969&toneId=6015090011&language=English&priority=0&paymentMode=2
     /*  private buyMusicChannelAPI(): void 
     { 
             console.log("buyMusicChannelAPI() invoked ##########BUY MUSIC CHANNEL ###############");
             let buyMusicChannelDto = new BuyMusicChannelDtoImpl();
             buyMusicChannelDto.setServiceId("7");
             buyMusicChannelDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
             buyMusicChannelDto.setToneId(6015090020);
             buyMusicChannelDto.setLanguage(this.getContext().getUserContext().getLanguage());
             buyMusicChannelDto.setPriority("0");
             buyMusicChannelDto.setPaymentMode("2");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getBuyMusicChannel()
             .success((buyMusicChannelResponse: BuyMusicChannelResponse)=>
             {
                 console.log("getMusicBoxContentsAPI success ###############BUY MUSIC CHANNEL#################");
                 this.getAPIModelHandler().onSuccess(buyMusicChannelResponse.getAPIFeature(), 
                 buyMusicChannelResponse.getDescription(), buyMusicChannelResponse);
              })
             .failure((buyMusicChannelResponse: BuyMusicChannelResponse)=>
              {
                this.getAPIModelHandler().onFailure(buyMusicChannelResponse.getAPIFeature(), 
                buyMusicChannelResponse.getDescription(), undefined);
              })
             .execute(new BuyMusicChannelRequestImpl(buyMusicChannelDto));
     } */

     /* msisdn=504843969&clientTxnId=3068466611&language=English&identifier=AddToWishList&contentId=265145|0&
     contentName=ALLAHOMMA AHDENA FIMAN HADEIT&path=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fTO9eb7I7ccCSvtxOpEhxZbTSoUMudpglIgBcS0kFMOrfRp5KT5lW1Q&
     previewImage=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fhd2VQisqriiPd365+GXOkYk4Q9H2TMjmy652NyJDOi4&
     album=ALLAHOMMA AHDENA FIMAN HADEIT&artist=AL SHEIKH NASSER AL QATAMI&price=0&wishlistType=1&likeCount=586 */
     /*   private addToWishList(): void 
     { 
             console.log("addToWishList() invoked ##########ADDWISHLIST###############");
             let addToWishlistDto = new AddToWishlistDtoImpl();
             addToWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
             addToWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
             addToWishlistDto.setIdentifier("AddToWishList");
             addToWishlistDto.setContentId("954353|0");
             addToWishlistDto.setContentName("ANYONE");
             addToWishlistDto.setPath("JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fezn5jq7tVXeEaSBg+Vb24frhORSIGtawWXRKCpr4Hzj+xgATMN9Z7EVXsPYutttZh8gcDJd3gG8=");
             addToWishlistDto.setPreviewImage("JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fezn5jq7tVXeEaSBg+Vb24fjejlGKZAAn2i57K8UVhUrRGFsRxyicVAF097gUu2+m1YC9aYURhMefWPgLaR2GYHU909st7/Rw");
             addToWishlistDto.setAlbum("ANYONE");
             addToWishlistDto.setArtist("DEMI LOVATO");
             addToWishlistDto.setPrice("0");
             addToWishlistDto.setWishlistType("1");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getAddToWishlist()
             .success((addToWishlistResponse: AddToWishlistResponse)=>
             {
                 console.log("addToWishList() success ###############ADDWISHLIST#################");
                 this.getAPIModelHandler().onSuccess(addToWishlistResponse.getAPIFeature(), 
                 addToWishlistResponse.getDescription(), addToWishlistResponse);
               
              })
             .failure((addToWishlistResponse: AddToWishlistResponse)=>
              {
                this.getAPIModelHandler().onFailure(addToWishlistResponse.getAPIFeature(), 
                addToWishlistResponse.getDescription(), undefined);
              })
             .execute(new AddToWishlistRequestImpl(addToWishlistDto));
     } */

//clientTxnId=3068466611&language=English&msisdn=504843969&wishlistType=1&identifier=DeleteFromWishList&catagoryId=3660     

     /* private deleteFromWishList(): void 
     { 
             console.log("deleteWishList() invoked ##########DeleteWISHLIST###############");
             let deleteFromWishlistDto = new DeleteFromWishlistDtoImpl();
             deleteFromWishlistDto.setIdentifier("DeleteFromWishList");
             deleteFromWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
             deleteFromWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
             deleteFromWishlistDto.setWishlistType("1");
             deleteFromWishlistDto.setCatagoryId("3742");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getDeleteFromWishlist()
             .success((deleteFromWishlistResponse: DeleteFromWishlistResponse)=>
             {
                 console.log("deleteWishList success ###############DeleteWISHLIST#################");
                 this.getAPIModelHandler().onSuccess(deleteFromWishlistResponse.getAPIFeature(), 
                 deleteFromWishlistResponse.getDescription(), deleteFromWishlistResponse.getDeleteFromWishlistDto());
               
              })
             .failure((deleteFromWishlistResponse: DeleteFromWishlistResponse)=>
              {
                this.getAPIModelHandler().onFailure(deleteFromWishlistResponse.getAPIFeature(), 
                deleteFromWishlistResponse.getDescription(), undefined);
              })
             .execute(new DeleteFromWishlistRequestImpl(deleteFromWishlistDto));
     } */

     /*  private logoutAPI(): void 
     { 
             console.log("logoutAPI() invoked ##########LOGOUT###############");
             let logoutDto = new LogoutDtoImpl();
             logoutDto.setRefreshToken(this.getContext().getUserContext().getRefreshToken());
    
             this.getAPIProcesssorFactory().getMyAccountProcessorFactory()
             .getLogoutDetails()
             .success((logoutResponse: LogoutResponse)=>
             {
                 console.log("logout success ###############LOGOUT#################");
                 this.getAPIModelHandler().onSuccess(logoutResponse.getAPIFeature(), 
                 logoutResponse.getDescription(), logoutResponse.getAPIFeature());
               
              })
             .failure((logoutResponse: LogoutResponse)=>
              {
                this.getAPIModelHandler().onFailure(logoutResponse.getAPIFeature(), 
                logoutResponse.getDescription(), undefined);
              })
             .execute(new LogoutRequestImpl(logoutDto));
     } */

     /* private packStatusAPI(): void 
     { 
             console.log("packStatusAPI() invoked ##########PPPPPAAAAACCCCKKK###############");
             let packStatusDto = new PackStatusDtoImpl();
             packStatusDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
    
             this.getAPIProcesssorFactory().getPackStatusProcessorFactory()
             .getPackStatus()
             .success((packStatusResponse: PackStatusResponse)=>
             {
                 console.log("packStatusAPI success ###############PPPPPAAAAACCCCKKK#################");
                 this.getAPIModelHandler().onSuccess(packStatusResponse.getAPIFeature(), 
                 packStatusResponse.getDescription(), packStatusResponse.getPackStatusDto());
               
              })
             .failure((packStatusResponse: PackStatusResponse)=>
              {
                this.getAPIModelHandler().onFailure(packStatusResponse.getAPIFeature(), 
                packStatusResponse.getDescription(), undefined);
              })
             .execute(new PackStatusRequestImpl(packStatusDto));
     } */

    // private listLikeToneAPI(): void 
    // { 
    //         console.log("listLikeToneAPI() invoked ##########333333333###############");
    //         let listLikeTone = new ListLikeToneDtoImpl();
    //         listLikeTone.setAPartyMsisdn("0504843969");
    
    //         this.getAPIProcesssorFactory().getListLikeToneProcessorFactory()
    //         .getListLikeToneDetails()
    //         .success((listLikeToneResponse: ListLikeToneResponse)=>
    //         {
    //             console.log("list like tone success ###############333333333#################");
    //             this.getAPIModelHandler().onSuccess(listLikeToneResponse.getAPIFeature(), 
    //             listLikeToneResponse.getDescription(), listLikeToneResponse.getListLikeToneDto());
               
    //          })
    //         .failure((listLikeToneResponse: ListLikeToneResponse)=>
    //          {
    //            this.getAPIModelHandler().onFailure(listLikeToneResponse.getAPIFeature(), 
    //            listLikeToneResponse.getDescription(), undefined);
    //          })
    //         .execute(new ListLikeToneRequestImpl(listLikeTone));

    //         this.getProfileDetailsAPI();

    // }

    // private invokeGetBannerDetailsAPI(): void 
    // { 
    //         console.log("invokeGetBannerDetailsAPI() invoked #########################");
    //         let getBannerDto = new GetBannerDtoImpl();
    //         getBannerDto.setIdentifier("GetBannerSongs"); // Hardcoded
    //         getBannerDto.setBannerOrder("4"); // From Home get banner API response
    //         getBannerDto.setBannerType("3"); 
    //         //Type of Banner.  4 for English Pre booking, 5 for Arabic Pre booking, 3 for English Manual, 6 for Arabic Manual
    
    //         this.getAPIProcesssorFactory().getGetBannerDetailsProcessorFactory()
    //         .getGetBannerDetails()
    //         .success((getBannerDetailsResponse: GetBannerDetailsResponse)=>
    //         {
    //             console.log("get banner details success ################################");
    //             this.getAPIModelHandler().onSuccess(getBannerDetailsResponse.getAPIFeature(), 
    //             getBannerDetailsResponse.getDescription(), getBannerDetailsResponse.getListOfGetBannerDtos());
               
    //          })
    //         .failure((getBannerDetailsResponse: GetBannerDetailsResponse)=>
    //          {
    //            this.getAPIModelHandler().onFailure(getBannerDetailsResponse.getAPIFeature(), 
    //            getBannerDetailsResponse.getDescription(), undefined);
    //          })
    //         .execute(new GetBannerDetailsRequestImpl(getBannerDto));

    //        this.invokeGetPlaylistAPI();
    // } 

    // private invokeGetPlaylistAPI(): void 
    // { 
    //         console.log("invokeGetPlaylistAPI() invoked ##########1111111111111111###############");
    //         let getPlaylistDto = new GetPlaylistDtoImpl();
    //         getPlaylistDto.setToneCode(""); // Empty
    //         getPlaylistDto.setType("MB"); // hardcoded
    //         getPlaylistDto.setIsAll("T");  // T or F
    //         getPlaylistDto.setContentTypeId("2"); //hardcoded
    //         getPlaylistDto.setLanguage(this.getContext().getUserContext().getLanguage());
    //         getPlaylistDto.setClientSessionId("998671752");
    
    //         this.getAPIProcesssorFactory().getPlaylistProcessorFactory()
    //         .getPlaylist()
    //         .success((getPlaylistResponse: GetPlaylistResponse)=>
    //         {
    //             console.log("get playlist success ###############111111111111111#################");
    //             this.getAPIModelHandler().onSuccess(getPlaylistResponse.getAPIFeature(), 
    //             getPlaylistResponse.getDescription(), getPlaylistResponse.getGetPlaylistDto());
               
    //          })
    //         .failure((getPlaylistResponse: GetPlaylistResponse)=>
    //          {
    //            this.getAPIModelHandler().onFailure(getPlaylistResponse.getAPIFeature(), 
    //            getPlaylistResponse.getDescription(), undefined);
    //          })
    //         .execute(new GetPlaylistRequestImpl(getPlaylistDto));

    //         this.invokeBannerSearchAPI();
    // }

    // private invokeBannerSearchAPI(): void 
    // { 
    //         console.log("invokeBannerSearchAPI() invoked ##########22222222222###############");
    //         let bannerSearchDto = new BannerSearchDtoImpl();
    //         bannerSearchDto.setSearchKey("");
    //         bannerSearchDto.setLanguage(this.getContext().getUserContext().getLanguage());
    //         bannerSearchDto.setType("BS");
    //         bannerSearchDto.setPageNumber(1);
    //         bannerSearchDto.setPagePerCount(20);
    
    //         this.getAPIProcesssorFactory().getBannerSearchProcessorFactory()
    //         .getBannerSearch()
    //         .success((bannerSearchResponse: BannerSearchResponse)=>
    //         {
    //             console.log("get playlist success ###############222222222222#################");
    //             this.getAPIModelHandler().onSuccess(bannerSearchResponse.getAPIFeature(), 
    //             bannerSearchResponse.getDescription(), bannerSearchResponse.getListOfSearchBannerDtos());
               
    //          })
    //         .failure((bannerSearchResponse: BannerSearchResponse)=>
    //          {
    //            this.getAPIModelHandler().onFailure(bannerSearchResponse.getAPIFeature(), 
    //            bannerSearchResponse.getDescription(), undefined);
    //          })
    //         .execute(new BannerSearchRequestImpl(bannerSearchDto));

    // }


    /* private getFeatured1()
    {
        let banner2 = new FeaturedCategoryDtoImpl();
        banner2.setTitle("English");
        banner2.setListOfTones(this.getListOfTones());

        return banner2;
    }

    private getFeatured2()
    {
        let banner1 = new FeaturedCategoryDtoImpl();
        banner1.setTitle("Arabic");
        banner1.setListOfTones(this.getListOfTones1());

        return banner1;
    } */

    private getFeatured3()
    {
        let banner1 = new FeaturedCategoryDtoImpl();
        banner1.setTitle("Arabic");
        banner1.setListOfTones(this.getListOfTones1());

        return banner1;
    }

    private getListOfTones1()
    {  let tone1 = new ToneDtoImpl();
        tone1.setId("9");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk");
        tone1.setImgPath("http://placehold.it/120x120&text=image9");
        tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone2 = new ToneDtoImpl();
        tone2.setId("10");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk");
        tone2.setImgPath("http://placehold.it/120x120&text=image10");
        tone2.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3");

        let tone3 = new ToneDtoImpl();
        tone3.setId("11");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk");
        tone3.setImgPath("http://placehold.it/120x120&text=image11");
        tone3.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_5MG.mp3");

        let tone4 = new ToneDtoImpl();
        tone4.setId("12");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image12");
        tone4.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone5 = new ToneDtoImpl();
        tone5.setId("13");
        tone5.setToneName("1234rsva");
        tone5.setArtistName("987ytrfgbnmk");
        tone5.setImgPath("http://placehold.it/120x120&text=image13");
        tone5.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone6 = new ToneDtoImpl();
        tone6.setId("14");
        tone6.setToneName("1234rsva");
        tone6.setArtistName("987ytrfgbnmk");
        tone6.setImgPath("http://placehold.it/120x120&text=image14");

        let tone7 = new ToneDtoImpl();
        tone7.setId("15");
        tone7.setToneName("1234rsva");
        tone7.setArtistName("987ytrfgbnmk");
        tone7.setImgPath("http://placehold.it/120x120&text=image15");

        let tone8 = new ToneDtoImpl();
        tone8.setId("16");
        tone8.setToneName("1234rsva");
        tone8.setArtistName("987ytrfgbnmk");
        tone8.setImgPath("http://placehold.it/120x120&text=image16");

        return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8];
    } 

    /*private getListOfTones()
    {  let tone1 = new ToneDtoImpl();
        tone1.setId("1");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk");
        tone1.setImgPath("http://placehold.it/120x120&text=image1");
        tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone2 = new ToneDtoImpl();
        tone2.setId("2");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk");
        tone2.setImgPath("http://placehold.it/120x120&text=image2");
        tone2.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3");

        let tone3 = new ToneDtoImpl();
        tone3.setId("3");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk");
        tone3.setImgPath("http://placehold.it/120x120&text=image3");
        tone3.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_5MG.mp3");

        let tone4 = new ToneDtoImpl();
        tone4.setId("4");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image4");
        tone4.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone5 = new ToneDtoImpl();
        tone5.setId("5");
        tone5.setToneName("1234rsva");
        tone5.setArtistName("987ytrfgbnmk");
        tone5.setImgPath("http://placehold.it/120x120&text=image5");
        tone5.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone6 = new ToneDtoImpl();
        tone6.setId("6");
        tone6.setToneName("1234rsva");
        tone6.setArtistName("987ytrfgbnmk");
        tone6.setImgPath("http://placehold.it/120x120&text=image6");

        let tone7 = new ToneDtoImpl();
        tone7.setId("7");
        tone7.setToneName("1234rsva");
        tone7.setArtistName("987ytrfgbnmk");
        tone7.setImgPath("http://placehold.it/120x120&text=image7");

        let tone8 = new ToneDtoImpl();
        tone8.setId("8");
        tone8.setToneName("1234rsva");
        tone8.setArtistName("987ytrfgbnmk");
        tone8.setImgPath("http://placehold.it/120x120&text=image8");

        return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8];
    }

    /* private getCategoriesData(): CategoryDto[]
    {
        let list: CategoryDto[] = [];

        let categorydto1 = new CategoryDtoImpl();
        categorydto1.setId("1");
        categorydto1.setTitle("Arabic");
        categorydto1.setImgPath("http://placehold.it/120x120&text=image1");

        let categorydto2 = new CategoryDtoImpl();
        categorydto2.setId("2");
        categorydto2.setTitle("Sudanese");
        categorydto2.setImgPath("http://placehold.it/120x120&text=image2");

        let categorydto3 = new CategoryDtoImpl();
        categorydto3.setId("3");
        categorydto3.setTitle("Islamic");
        categorydto3.setImgPath("http://placehold.it/120x120&text=image3");

        let categorydto4 = new CategoryDtoImpl();
        categorydto4.setId("4");
        categorydto4.setTitle("English");
        categorydto4.setImgPath("http://placehold.it/120x120&text=image4");

        let categorydto7 = new CategoryDtoImpl();
        categorydto7.setId("7");
        categorydto7.setTitle("Khalej");
        categorydto7.setImgPath("http://placehold.it/120x120&text=image7");

        let categorydto5 = new CategoryDtoImpl();
        categorydto5.setId("5");
        categorydto5.setTitle("Hindi");
        categorydto5.setImgPath("http://placehold.it/120x120&text=image5");

        let categorydto6 = new CategoryDtoImpl();
        categorydto6.setId("6");
        categorydto6.setTitle("English");
        categorydto6.setImgPath("http://placehold.it/120x120&text=image6");

        list.push(categorydto1);
        list.push(categorydto2);
        list.push(categorydto3);
        list.push(categorydto4);
        list.push(categorydto5);
        list.push(categorydto6);
        list.push(categorydto7);
        return list;
    }     */
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homeapimodel.tsx